<template>
	<div class="energy-right-box">
		<div class="top">
			<div class="left">
				<div class="cell-top">
					<pcsbianliuqijiankong></pcsbianliuqijiankong>
				</div>
				<div class="cell-bottom">
					<chunengdanyuanjiankong></chunengdanyuanjiankong>
				</div>
			</div>
			<div class="right">
				<div class="cell-top">
					<youwugonglvjiankong></youwugonglvjiankong>
				</div>
				<div class="cell-bottom">
					<shishigaojing></shishigaojing>
				</div>
			</div>
		</div>
		<div class="bottom">
			<gaojingliebiao></gaojingliebiao>
		</div>
	</div>
</template>

<script>
	import youwugonglvjiankong from '@/views/components/energyStorage/youwugonglvjiankong.vue'
	import gaojingliebiao from '@/views/components/energyStorage/gaojingliebiao.vue'
	import pcsbianliuqijiankong from '@/views/components/energyStorage/pcsbianliuqijiankong.vue'
	import shishigaojing from '@/views/components/energyStorage/shishigaojing.vue'
	import chunengdanyuanjiankong from '@/views/components/energyStorage/chunengdanyuanjiankong.vue'
	export default{
		components: {
			youwugonglvjiankong,
			gaojingliebiao,
			pcsbianliuqijiankong,
			shishigaojing,
			chunengdanyuanjiankong
		}
	}
</script>

<style scoped lang="scss">
	.energy-right-box{
		width: 1200px;
		height: 1470px;
		margin-top: 100px;
		.top{
			height: 940px;
			width: 100%;
			display: flex;
			.left{
				width: 50%;
				height: 980px;
				.cell-top{
					height:430px;
					width: 100%;
				}
				.cell-bottom{
					height:550px;
					width: 100%;
				}
			}
			.right{
				width: 50%;
				height: 980px;
				.cell-top{
					height:490px;
					width: 100%;
				}
				.cell-bottom{
					height:490px;
					width: 100%;
				}
			}
		}
		.bottom{
			height: 440px;
			width: 100%;
		}
	}
</style>